import { i18n } from '@konova/i18n';

export default i18n;
